const SummaryType = Object.freeze({
  RETAIL_CLIENT: "RETAIL_CLIENT",
  NON_RETAIL_CLIENT: "NON_RETAIL_CLIENT",
});

export default SummaryType;
